import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Button from "./components/Button";
import ButtonSettings from "./components/ButtonSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/round-toggle_on-24px.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'button',
    group: ElementGroup.BASIC,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_BUTTON'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        type: 'primary',
        htmlType: 'submit',
        text: messages['PAGEBUIDER_ELEMENT_TEXT_SUBMIT'],
      },
      formSettings: {

      },
      settings: {
        // cols: { span: 2, offset: 0 },
        width: { value: "100%" },
        margin: {
          desktop: { all: 0 },
          mobile: { all: 0 },
          advanced: true
        },
        padding: {
          desktop: { top: 5, left: 0, right: 0, bottom: 5 },
          mobile: { top: 5, left: 0, right: 0, bottom: 5 },
          advanced: true
        }
      }
    },
    pluginComponent: Button, // 插件渲染组件
    pluginSettingComponent: ButtonSettings, // 插件设置项组件
  }
}
